export enum Urls {
  Portfolio = 'https://mytours.homeontour.com'
}
